import React, { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { useGetQueryStr } from '../hook'
import { theme } from '../styles/theme'

const PagenationContainer = styled.div`
  display: flex;
  gap: 5px;
`
const PageButton = styled.button<{ $isCurrentPage: boolean }>`
  background-color: ${({ $isCurrentPage }) => ($isCurrentPage ? theme.colors.green : 'transparent')};
  color: ${({ $isCurrentPage }) => ($isCurrentPage ? theme.colors.white : theme.colors.blackgray)};
  border: none;
  width: 40px;
  height: 40px;
  font-size: 1rem;
  border-radius: 8px;
  cursor: pointer;
  opacity: 0.8;
  transition:
    opacity 0.2s ease,
    transform 0.2s ease; /* 색상과 크기 전환 효과 */

  &:hover {
    opacity: 1; /* 호버 시 색상 (진한 파란색) */
    background-color: ${({ $isCurrentPage }) => ($isCurrentPage ? theme.colors.green : theme.colors.gray)};
    transform: scale(1.05); /* 호버 시 약간 확대 효과 */
  }
`
type PagenationProps = {
  totalPage: number
  isLoading: boolean
}

const Pagenation = ({ totalPage = 1, isLoading }: PagenationProps) => {
  const { queryParams, changeQuery } = useGetQueryStr()
  const currentPage = queryParams.get('pageNo') ? Number(queryParams.get('pageNo')) : 1

  const getTen = (num: number) => num - 1 - ((num - 1) % 10)
  const isSameTerm = (cur: number, total: number) => !(getTen(cur) - getTen(total))
  const getPageTerm = (cur: number, total: number) => (isSameTerm(cur, total) ? total - getTen(cur) : 10)
  const setPageTerm = (str: string, cur: number) => (str === 'next' ? getTen(cur) + 11 : getTen(cur))

  const pages = useMemo(() => [...Array(getPageTerm(currentPage, totalPage))].map((_, index) => getTen(currentPage) + index + 1), [currentPage, totalPage])
  const setCurrentPage = (pageNo: number) => changeQuery('pageNo', pageNo)

  if(isLoading) return <>...</>
  if(currentPage > totalPage) return <>데이터가 없습니다.</>
  if(currentPage <= 0) return <> 잘못된 페이지 번호 입니다.</>
  
  return (
    <PagenationContainer>
      {currentPage > 10 && (
        <PageButton $isCurrentPage={false} onClick={() => setCurrentPage(setPageTerm('prev', currentPage))}>
          이전
        </PageButton>
      )}
      {pages.map((v) => (
        <PageButton key={v} $isCurrentPage={currentPage === v} onClick={() => setCurrentPage(v)}>
          {v}
        </PageButton>
      ))}
      {!isSameTerm(currentPage, totalPage) && (
        <PageButton $isCurrentPage={false} onClick={() => setCurrentPage(setPageTerm('next', currentPage))}>
          다음
        </PageButton>
      )}
    </PagenationContainer>
  )
}

export default Pagenation
